import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const propertyOwnerPlotSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    plotArea: validationRules.plotArea,
    separableSpace: validationRules.separableSpace,
    price: usePurchasePriceOnRequestCondition,
  },
  contactInfo: defaultContactInfo,
  description: defaultDescription,
  otherFacilities: {
    gfz: validationRules.gfzField,
    grz: validationRules.grzField,
  },
}
